import { EditOutlined } from "@ant-design/icons";
import { Button, Col, notification, Rate, Row, Spin, Tag, Typography } from "antd";
import { BackbuttonComponent, ContainerComponent } from "../../../components";
import { useQuery } from "../../../hooks";
import { Roles, useAuth } from "../../../providers";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { DevBoostEditRoute } from "..";
import { DevBoostStageCard } from "../partials/dev-boost-stage-card.partial.jsx";

export const DevBoostDetail = () => {
    const { user } = useAuth();
    const { id } = useParams();
    const [, contextHolder] = notification.useNotification();
    const {
        data: devboost,
        loading,
        execute,
    } = useQuery({
        url: `/devboost/${id}`,
        options: { method: "GET" },
        lazy: true,
    });

    useEffect(() => {
        execute();
        // execute no es estable (no memoizado en useQuery); incluirlo en deps provoca loop infinito
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <>
            {contextHolder}
            <ContainerComponent>
                {loading ? (
                    <Spin size="large" />
                ) : devboost ? (
                    <>
                        <Row style={{ marginTop: 24 }}>
                            <Col span={2}>
                                <BackbuttonComponent />
                            </Col>
                        </Row>
                        <ContainerComponent
                            style={{
                                marginBottom: 8
                            }}
                        >
                            <Row>
                                <Col span={24}>
                                    <Row justify="space-between" align="middle">
                                        <Typography.Title style={{ textAlign: "left" }} level={2}>
                                            {devboost.title}
                                        </Typography.Title>
                                        {(user?.role === Roles.COPILOT || user?.role === Roles.ADMIN) && (
                                            <Link to={DevBoostEditRoute({ devboostId: devboost.id })}>
                                                <Button icon={<EditOutlined />}>Editar Caso de Éxito</Button>
                                            </Link>
                                        )}
                                    </Row>
                                </Col>
                            </Row>
                        </ContainerComponent>
                        <ContainerComponent
                            style={{
                                padding: 24,
                                marginBottom: 24,
                                backgroundColor: "#ffffff",
                                borderRadius: 16,
                                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <Row>
                                <Col span={24} style={{ textAlign: "left" }}>
                                    <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "1rem" }}>
                                        Descripción del problema:
                                    </Typography.Text>
                                    <Typography.Text style={{ fontWeight: 600, color: "#888", marginLeft: 8 }}>
                                        {devboost.problemDescription}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: "left" }}>
                                    <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "1rem" }}>
                                        Industria/Sector:
                                    </Typography.Text>
                                    <Typography.Text style={{ fontWeight: 600, color: "#888", marginLeft: 8 }}>
                                        {devboost.industry}
                                    </Typography.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: "left" }}>
                                    <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "1rem" }}>
                                        Tecnologías Principales Utilizadas:
                                    </Typography.Text>
                                    <span style={{ marginLeft: 8 }}>
                                        {devboost.technologies.map((tech, idx) => (
                                            <Tag
                                                color="cyan"
                                                key={tech.id}
                                                style={{
                                                    marginRight: 6,
                                                    background: "#e6fffb",
                                                    color: "#13c2c2",
                                                    border: "1px solid #13c2c2"
                                                }}
                                            >
                                                {tech.name}
                                            </Tag>
                                        ))}
                                    </span>
                                </Col>
                            </Row>
                        </ContainerComponent>
                        <ContainerComponent
                            style={{
                                marginBottom: 8
                            }}
                        >
                            <Row>
                                <Col span={24}>
                                    <Typography.Title style={{ textAlign: "left" }} level={3}>
                                        Impacto de Copilot por Etapa de Desarrollo
                                    </Typography.Title>
                                </Col>
                            </Row>
                        </ContainerComponent>
                        <ContainerComponent
                            style={{
                                marginBottom: 8,
                            }}
                        >
                            <Row gutter={[16, 16]}>
                                <Col span={24} md={12} lg={12}>
                                    <DevBoostStageCard
                                        title="Planificación y Diseño"
                                        impact={devboost.impactPlanning}
                                        example={devboost.examplePlanning}
                                        optimizationRange={devboost.optimizationRangePlanning}
                                    />
                                </Col>
                                <Col span={24} md={12} lg={12}>
                                    <DevBoostStageCard
                                        title="Desarrollo y Codificación"
                                        impact={devboost.impactDev}
                                        example={devboost.exampleDev}
                                        optimizationRange={devboost.optimizationRangeDev}
                                    />
                                </Col>
                                <Col span={24} md={12} lg={12}>
                                    <DevBoostStageCard
                                        title="Pruebas y Depuración"
                                        impact={devboost.impactTesting}
                                        example={devboost.exampleTesting}
                                        optimizationRange={devboost.optimizationRangeTesting}
                                    />
                                </Col>
                                <Col span={24} md={12} lg={12}>
                                    <DevBoostStageCard
                                        title="Despliegue y Operaciones (DevOps)"
                                        impact={devboost.impactDevOps}
                                        example={devboost.exampleDevOps}
                                        optimizationRange={devboost.optimizationRangeDevOps}
                                    />
                                </Col>
                            </Row>
                        </ContainerComponent>
                        <ContainerComponent
                            style={{
                                padding: 24,
                                marginBottom: 24,
                                backgroundColor: "#ffffff",
                                borderRadius: 16,
                                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <Row>
                                <Col span={24}>
                                    <Typography.Title style={{ textAlign: "left" }} level={3}>
                                        Impacto General y Retroalimentación
                                    </Typography.Title>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: "left" }}>
                                    <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "1rem" }}>
                                        Calificación General de Satisfacción:
                                    </Typography.Text>
                                    <Rate value={devboost.score} disabled />
                                </Col>
                                <Col span={24} style={{ textAlign: "left" }}>
                                    <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "1rem" }}>
                                        Principales Beneficios Obtenidos:
                                    </Typography.Text>
                                    <span style={{ marginLeft: 8 }}>
                                        {devboost.benefits.map((benefit, idx) => (
                                            <Tag
                                                color="cyan"
                                                key={benefit + idx}
                                                style={{
                                                    marginRight: 6,
                                                    background: "#fff7e6",
                                                    color: "#fa8c16",
                                                    border: "1px solid #fa8c16"
                                                }}
                                            >
                                                {benefit}
                                            </Tag>
                                        ))}
                                    </span>
                                </Col>
                                <Col span={24} style={{ textAlign: "left" }}>
                                    <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "1rem" }}>
                                        Desafíos o Limitaciones Encontradas:
                                    </Typography.Text>
                                    <Typography.Text style={{ fontWeight: 600, color: "#888", marginLeft: 8 }}>
                                        {devboost.challenge || "No se reportaron desafíos específicos."}
                                    </Typography.Text>
                                </Col>
                                <Col span={24} style={{ textAlign: "left" }}>
                                    <Typography.Text style={{ fontWeight: 700, color: "var(--color-primary)", fontSize: "1rem" }}>
                                        Comentarios Adicionales:
                                    </Typography.Text>
                                    <Typography.Text style={{ fontWeight: 600, color: "#888", marginLeft: 8 }}>
                                        {devboost.comment}
                                    </Typography.Text>
                                </Col>
                            </Row>
                        </ContainerComponent>
                    </>
                ) : (
                    <>
                        <Row>
                            <Col span={2}>
                                <BackbuttonComponent
                                    style={{
                                        marginBottom: 16,
                                        display: "block",
                                        textAlign: "left",
                                    }}
                                />
                            </Col>
                        </Row>
                        <Typography.Title level={4} type="danger">
                            No se encontró información del caso de éxito.
                        </Typography.Title>
                    </>
                )}
            </ContainerComponent>
        </>
    );
};
